import { VendorDataAPI } from "../common/lib/API/VendorDataAPI";
import { ApplicationDataAPI } from "../common/lib/API/ApplicationDataAPI";
import { UsStatesDataAPI } from "../common/lib/API/UsStatesDataAPI";

const VendorRepo = {
    // ************* Vendor start ***************
    async getVendor(data) {
        let response = await VendorDataAPI.getVendor(data);
        return response;
    },
    async getVendors(name, offset) {
        let response = await VendorDataAPI.getVendors(name, offset)
        return response;
    },
    async getAllVendors(offset) {
        let response = await VendorDataAPI.getAllVendors(offset)
        return response;
    },
    async addVendor(data) {
        let response = await VendorDataAPI.addVendor(data);
        return response;
    },
    async getApplicationLocationsById(app) {
        let response = await ApplicationDataAPI.fetchApplicationLocationsById(app.id, app.broker_id)
        return response;
    },
    async getUsStates() {
        let response = await UsStatesDataAPI.getUsStates();
        return response;
    }
    // ************* Vendor end ***************
}

export default VendorRepo;